import { Box, Chip, Container, Typography } from "@mui/material";
import { motion } from "framer-motion";
import AuroraBackground from "../visuals/AuroraBackground";
import { gradients } from "../../theme/theme";

const MotionDiv = motion.div;

/** Compact hero used at the top of inner pages (News / Apps / Contacts). */
export default function PageHero({ eyebrow, title, subtitle }) {
  return (
    <Box
      sx={{
        position: "relative",
        overflow: "hidden",
        pt: { xs: 5, md: 8 },
        pb: { xs: 6, md: 9 },
        textAlign: "center",
      }}
    >
      <AuroraBackground />
      <Container maxWidth="md" sx={{ position: "relative", zIndex: 1 }}>
        <MotionDiv
          initial={{ opacity: 0, y: 24 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.7, ease: [0.21, 0.6, 0.27, 0.97] }}
        >
          {eyebrow && (
            <Chip
              label={eyebrow}
              size="small"
              sx={{
                mb: 2.5,
                fontWeight: 700,
                letterSpacing: "0.08em",
                color: "primary.main",
                bgcolor: (t) =>
                  t.palette.mode === "dark" ? "rgba(79,124,255,0.14)" : "rgba(79,124,255,0.1)",
                border: "1px solid rgba(79,124,255,0.3)",
              }}
            />
          )}
          <Typography variant="h2" sx={{ fontSize: { xs: "2.2rem", md: "3.2rem" }, mb: 2 }}>
            {title}
            <Box
              component="span"
              sx={{
                display: "block",
                width: 72,
                height: 4,
                mt: 2,
                mx: "auto",
                borderRadius: 2,
                background: gradients.brand,
              }}
            />
          </Typography>
          {subtitle && (
            <Typography color="text.secondary" sx={{ fontSize: { xs: "1rem", md: "1.15rem" }, maxWidth: 620, mx: "auto" }}>
              {subtitle}
            </Typography>
          )}
        </MotionDiv>
      </Container>
    </Box>
  );
}
